import {observer} from "mobx-react";
import {WidgetProps} from "controls/designer/features/widgets/widgetProps";
import {CompassWidgetConfig} from "areas/metrics/widgets/Compass/config";
import {useMetricValue} from "areas/metrics/hooks/useMetricValue";
import React from "react";
import {getHighchartsConfig} from "areas/metrics/widgets/Compass/utils/getHighchartsConfig";
import {HighchartsWrapper} from "components/HighchartsWrapper";
import {AntAlert} from "controls/react/ant/antAlert";
import {i18n} from "core/localization";
import {AntSpin} from "controls/react/ant/antSpin";
import {AssetsRouter} from "areas/assets/bundleDescription";
import {DefaultWidgetWrapper} from "controls/designer/features/widgets/defaultWidgetWrapper";

export const CompassWidget = observer((props: WidgetProps<CompassWidgetConfig>) => {
	const {value, metricInfo, loaded, loading} = useMetricValue(props.config.metric)

	const chartConfig = React.useMemo(() => {
		if (!metricInfo)
			return {}

		return getHighchartsConfig(props.config, metricInfo, value)
	}, [metricInfo, value]);

	if(loading){
		return <AntSpin spinning={true} centered={true}/>
	}

	if (!loaded)
		return null

	if(value == null)
		return <AntAlert message={i18n('There is no data available')} type={"error"}/>

	return	<DefaultWidgetWrapper {...props}>
		<HighchartsWrapper onClick={() => props.navigator.go({url: AssetsRouter.details(metricInfo.qualifier.assetId)})}
		                   config={chartConfig}/>
	</DefaultWidgetWrapper>
})

export default CompassWidget;
